import type { Address, CreateAddressPayload } from "@/src/types/address";
import { apiFetch, MOBILE_API } from "./api";

export async function createAddress(
  token: string,
  payload: CreateAddressPayload
): Promise<Address> {
  const res = await apiFetch<{ success: boolean; data: Address }>(
    `${MOBILE_API}/address/`,
    { method: "POST", body: payload, token }
  );
  return res.data;
}

export async function getAddresses(token: string, userId: number): Promise<Address[]> {
  const res = await apiFetch<{ success: boolean; data: Address[] }>(
    `${MOBILE_API}/address/${userId}`,
    { token }
  );
  return Array.isArray(res.data) ? res.data : [];
}
